import React, { useState } from 'react';
import ResultViewAsQueue from './ResultViewAsQueue';
import ResultViewAsCalendar from './ResultViewAsCalendar';

const ResultView = () => {
  const [viewMode, setViewMode] = useState('queue'); // 'queue', 'calendar', or 'guided'
  const [workoutProgram, setWorkoutProgram] = useState([
    {
      day: 'Session 1',
      exercises: [
        {
          id: 'ex-1-1',
          exercise_type: 'squat',
          name: 'squat',
          sets: 3,
          reps: 10,
          weight: { value: 100, unit: 'kg' },
          tempo: [2, 0, 1, 0],
        },
        {
          id: 'ex-1-2',
          exercise_type: 'benchPress',
          name: 'benchPress',
          sets: 3,
          reps: 10,
          weight: { value: 80, unit: 'kg' },
          tempo: [2, 0, 1, 0],
        },
      ],
    },
    {
      day: 'Session 2',
      exercises: [
        {
          id: 'ex-2-1',
          exercise_type: 'pullUp',
          name: 'pullUp',
          sets: 3,
          reps: 10,
          weight: { value: 100, unit: 'kg' },
          tempo: [2, 0, 1, 0],
        },
        {
          id: 'ex-2-2',
          exercise_type: 'deadlift',
          name: 'deadlift',
          sets: 3,
          reps: 5,
          weight: { value: 100, unit: 'kg' },
          tempo: [2, 0, 1, 0],
        },
      ],
    },
  ]);

  return (
    <div className="">
      <h1>Upcoming Workout Sessions</h1>

      <div>
        {/* <span>
            <h3>Share this with your client:</h3>
            <span
            className="copy-link"
            onClick={() => navigator.clipboard.writeText('https://example.com/workout-program') && alert('Link copied!')}
            >
            Click to Copy a Link to https://example.com/workout-program
            </span>
        </span> */}
      </div>

      <div>
        
        <span
          className="get-google-sheet-export"
          onClick={() => alert('Not implemented yet, sorry!')}
        >
          Get a Google Sheet version
        </span>
        </div>

      <div className="view-switch">
        <label>
          <input
            type="radio"
            name="viewMode"
            value="queue"
            checked={viewMode === 'queue'}
            onChange={() => setViewMode('queue')}
          />
          Queue View
        </label>
        <label>
          <input
            type="radio"
            name="viewMode"
            value="calendar"
            checked={viewMode === 'calendar'}
            onChange={() => setViewMode('calendar')}
          />
          Calendar View
        </label>
      </div>
      
      {viewMode === 'queue' && <ResultViewAsQueue workoutProgram={workoutProgram} setWorkoutProgram={setWorkoutProgram} />}
      {viewMode === 'calendar' && <ResultViewAsCalendar workoutProgram={workoutProgram} setWorkoutProgram={setWorkoutProgram} />}
    </div>
  );
};

export default ResultView;